import React, { Component } from 'react';
import PropTypes from 'prop-types';
import '../../../styles/scss/style.css';

//Returning the component
class FormLabel extends Component {
	render() {
		return (
			<label
				htmlFor={this.props.for}
				className={`form__label ${this.props.classType}`}
				id={this.props.id}
			>
				{this.props.text}
			</label>
		)
	}
}

//Default properties if they are not set
FormLabel.defaultProps = {
	classType: ""
};

//Making sure that it has a text property when it's declared
FormLabel.propTypes = {
	classType: PropTypes.string,
	for: PropTypes.string,
	text: PropTypes.string.isRequired
}

export default FormLabel;


// WEBPACK FOOTER //
// ./src/redux/components/atoms/FormLabel.jsx